/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetFilterPresetDTO } from '../models/AssetFilterPresetDTO';
import type { AssetFilterPresetDTOODataListResponse } from '../models/AssetFilterPresetDTOODataListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AssetFilterPresetService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns AssetFilterPresetDTOODataListResponse Success
     * @throws ApiError
     */
    public static getAssetFilterPreset(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<AssetFilterPresetDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/AssetFilterPreset',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns AssetFilterPresetDTO Success
     * @throws ApiError
     */
    public static postAssetFilterPreset(
requestBody?: AssetFilterPresetDTO,
): CancelablePromise<AssetFilterPresetDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/AssetFilterPreset',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns AssetFilterPresetDTO Success
     * @throws ApiError
     */
    public static putAssetFilterPreset(
key: number,
requestBody?: AssetFilterPresetDTO,
): CancelablePromise<AssetFilterPresetDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/AssetFilterPreset/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteAssetFilterPreset(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/AssetFilterPreset/{key}',
            path: {
                'key': key,
            },
        });
    }

}
